// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "user.proto" (package "users", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { UserService } from "./user";
import type { DeleteUserResponse } from "./user";
import type { DeleteUserRequest } from "./user";
import type { GetUserDeletionImpactResponse } from "./user";
import type { GetUserDeletionImpactRequest } from "./user";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllUsersResponse } from "./user";
import type { GetAllUsersRequest } from "./user";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service users.UserService
 */
export interface IUserServiceClient {
    /**
     * @generated from protobuf rpc: GetAllUsers
     */
    getAllUsers(input: GetAllUsersRequest, options?: RpcOptions): UnaryCall<GetAllUsersRequest, GetAllUsersResponse>;
    /**
     * @generated from protobuf rpc: GetUserDeletionImpact
     */
    getUserDeletionImpact(input: GetUserDeletionImpactRequest, options?: RpcOptions): UnaryCall<GetUserDeletionImpactRequest, GetUserDeletionImpactResponse>;
    /**
     * @generated from protobuf rpc: DeleteUser
     */
    deleteUser(input: DeleteUserRequest, options?: RpcOptions): UnaryCall<DeleteUserRequest, DeleteUserResponse>;
}
/**
 * @generated from protobuf service users.UserService
 */
export class UserServiceClient implements IUserServiceClient, ServiceInfo {
    typeName = UserService.typeName;
    methods = UserService.methods;
    options = UserService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllUsers
     */
    getAllUsers(input: GetAllUsersRequest, options?: RpcOptions): UnaryCall<GetAllUsersRequest, GetAllUsersResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllUsersRequest, GetAllUsersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetUserDeletionImpact
     */
    getUserDeletionImpact(input: GetUserDeletionImpactRequest, options?: RpcOptions): UnaryCall<GetUserDeletionImpactRequest, GetUserDeletionImpactResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetUserDeletionImpactRequest, GetUserDeletionImpactResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteUser
     */
    deleteUser(input: DeleteUserRequest, options?: RpcOptions): UnaryCall<DeleteUserRequest, DeleteUserResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteUserRequest, DeleteUserResponse>("unary", this._transport, method, opt, input);
    }
}
